/* LIVANO Gallery Filter (Phase 2) — reversibel, fail-safe, theme-nativ.
 * Filtert die bestehende <media-gallery> per nativem [hidden]+initial-slide
 * (derselbe Mechanismus, den Drive fürs Collection-Filtern nutzt).
 * Datenquelle ausschliesslich: livano.gallery_media_map (als JSON im DOM).
 * KEIN Dateinamen-/Alt-Text-Matching. Bei jeder Unsicherheit -> alle Bilder.
 */
(function () {
  'use strict';
  var TAG = 'livano-gallery-filter';
  if (customElements.get(TAG)) return;

  function gidNum(gid) { return String(gid).split('/').pop().trim(); }
  function handleize(s) {
    return String(s).toLowerCase().normalize('NFKD').replace(/[^\w\s-]/g, '')
      .trim().replace(/[\s_]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  class LivanoGalleryFilter extends HTMLElement {
    connectedCallback() {
      this._state = 'filtered';
      this._ourHidden = new WeakSet();
      this._toggle = this.querySelector('[data-lv-toggle]');
      if (this._toggle) this._toggle.addEventListener('click', this._onToggle.bind(this));
      // Re-apply whenever the media-gallery is (re)inserted by a variant change.
      var host = this.parentElement || this;
      try {
        this._obs = new MutationObserver(this._onMutations.bind(this));
        this._obs.observe(host, { childList: true });
      } catch (e) { /* no-op */ }
      this._safeApply('filtered');
    }
    disconnectedCallback() { if (this._obs) this._obs.disconnect(); }

    _onMutations(muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n && n.nodeType === 1 && (n.tagName === 'MEDIA-GALLERY' || (n.querySelector && n.querySelector('media-gallery')))) {
            // fresh gallery from server (variant change) -> reset to filtered
            this._state = 'filtered';
            this._ourHidden = new WeakSet();
            this._safeApply('filtered');
            return;
          }
        }
      }
    }

    section() { return this.closest('.shopify-section, dialog') || document; }
    gallery() { return this.section().querySelector('media-gallery'); }

    map() {
      var s = this.section().querySelector('script.lv-gallery-map, script[data-lv-gallery-map]');
      if (!s) return null;
      try { var m = JSON.parse(s.textContent); return (m && typeof m === 'object') ? m : null; }
      catch (e) { return null; }
    }

    // Currently selected value of the visual option (from the variant picker). null if unknown.
    selectedValue(filterOption) {
      var h = handleize(filterOption);
      var sec = this.section();
      var fs = sec.querySelector('[data-option-name="' + h + '"]');
      if (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
        if (checked && checked.value) return checked.value;
        var sel = fs.querySelector('select');
        if (sel && sel.value) return sel.value;
      }
      return null;
    }

    slideshow(g) { return g.querySelector('[ref="slideshow"], slideshow-component'); }

    slideEls(g) { return Array.prototype.slice.call(g.querySelectorAll('slideshow-slide[data-media-id], [ref="slides[]"][data-media-id], [ref="media[]"][data-media-id]')); }
    thumbEls(g) { return Array.prototype.slice.call(g.querySelectorAll('button.slideshow-controls__thumbnail[data-media-id], [ref="thumbnails[]"][data-media-id]')); }

    // Full fail-safe validation. Returns Set of allowed numeric ids, or null to disable filtering.
    computeAllowed(g, m) {
      if (!m || m.version !== 1 || !m.filter_option || !m.values || typeof m.values !== 'object') return null;
      var sel = this.selectedValue(m.filter_option);
      if (!sel || !Object.prototype.hasOwnProperty.call(m.values, sel)) return null;
      var group = m.values[sel];
      if (!Array.isArray(group) || group.length === 0) return null;
      var general = Array.isArray(m.general) ? m.general : [];

      // Every media-id present in the DOM gallery.
      var domIds = {};
      var slides = this.slideEls(g);
      if (!slides.length) return null;
      slides.forEach(function (li) { domIds[li.getAttribute('data-media-id')] = true; });

      // All mapped ids (across ALL values + general) must exist in the DOM and cover it fully & uniquely.
      var seen = {}, total = 0, dup = false, unknown = false;
      Object.keys(m.values).forEach(function (k) {
        (Array.isArray(m.values[k]) ? m.values[k] : []).forEach(function (gid) {
          var id = gidNum(gid); total++;
          if (seen[id]) dup = true; seen[id] = true;
          if (!domIds[id]) unknown = true;
        });
      });
      general.forEach(function (gid) {
        var id = gidNum(gid); total++;
        if (seen[id]) dup = true; seen[id] = true;
        if (!domIds[id]) unknown = true;
      });
      if (dup || unknown) return null;                       // widerspruechlich / kaputte Referenz
      if (Object.keys(seen).length !== slides.length) return null; // nicht vollstaendig/deckungsgleich
      if (total !== slides.length) return null;

      var allowed = {};
      group.concat(general).forEach(function (gid) { allowed[gidNum(gid)] = true; });
      return allowed;
    }

    _safeApply(mode) { try { this._apply(mode); } catch (e) { this._fail(e); } }

    _apply(mode) {
      var g = this.gallery();
      if (!g) { this._hideToggle(); return; }
      var m = this.map();
      var allowed = this.computeAllowed(g, m);
      if (!allowed) { this._revealAll(g); this._hideToggle(); return; } // FAIL-SAFE: alle Bilder

      this._selValue = this.selectedValue(m.filter_option);
      if (mode === 'all') { this._revealAll(g); }
      else { this._filter(g, allowed); }
      this._showToggle();
      this._syncToggleLabel();
    }

    _filter(g, allowed) {
      var self = this;
      this.slideEls(g).concat(this.thumbEls(g)).forEach(function (el) {
        var ok = !!allowed[el.getAttribute('data-media-id')];
        if (ok) { self._unhide(el); }
        else { self._hide(el); }
      });
      this._activateFirstVisible(g);
    }

    _revealAll(g) {
      var self = this;
      this.slideEls(g).concat(this.thumbEls(g)).forEach(function (el) { self._unhide(el); });
    }

    _hide(el) { if (!el.hasAttribute('hidden')) { el.setAttribute('hidden', ''); } this._ourHidden.add(el); }
    _unhide(el) { if (this._ourHidden.has(el)) { el.removeAttribute('hidden'); this._ourHidden.delete(el); } }

    _activateFirstVisible(g) {
      var slides = this.slideEls(g);
      var idx = -1;
      for (var i = 0; i < slides.length; i++) { if (!slides[i].hasAttribute('hidden')) { idx = i; break; } }
      if (idx < 0) return;
      // Only move if the currently active slide got hidden.
      var ss = this.slideshow(g);
      if (!ss) return;
      var current = slides.findIndex ? slides.findIndex(function (s) { return s.getAttribute('aria-hidden') === 'false'; }) : -1;
      // Set native initial-slide (observed attribute -> re-select), and try the public API.
      try { ss.setAttribute('initial-slide', String(idx)); } catch (e) {}
      try {
        var mg = g;
        if (mg && mg.slideshow && typeof mg.slideshow.select === 'function') {
          requestAnimationFrame(function () { try { mg.slideshow.select(idx, undefined, { animate: false }); } catch (e) {} });
        }
      } catch (e) {}
    }

    _onToggle(e) {
      if (e) e.preventDefault();
      this._state = (this._state === 'all') ? 'filtered' : 'all';
      this._safeApply(this._state);
    }

    _syncToggleLabel() {
      if (!this._toggle) return;
      if (this._state === 'all') {
        this._toggle.textContent = this._selValue ? ('Nur ' + this._selValue + ' anzeigen') : 'Gefiltert anzeigen';
      } else {
        this._toggle.textContent = 'Alle Bilder anzeigen';
      }
    }
    _showToggle() { this.removeAttribute('hidden'); if (this._toggle) this._toggle.hidden = false; }
    _hideToggle() { this.setAttribute('hidden', ''); }

    _fail(e) {
      try { var g = this.gallery(); if (g) this._revealAll(g); } catch (x) {}
      this._hideToggle();
      if (window.console && console.warn) console.warn('[livano-gallery-filter] disabled (fail-safe):', e && e.message);
    }
  }

  customElements.define(TAG, LivanoGalleryFilter);
})();
